// extracted by mini-css-extract-plugin
module.exports = {"menuDesplegable":"styles_menuDesplegable__30HiS","linkAction":"styles_linkAction__2AbOT"};